export class WorkOrderAttachmentRawDto {
    fileName: string;
    fileBase64String: string;
    fileId: number;
    crudAction: string; // Action taken by user for attachment possible values: Add, Delete
}
